import React from 'react';
import { Link } from 'react-router-dom';

export default function Ultrasound() {
  return (
    <>
      <div className='services-item container' id='ultrasound'>
        <div className='row'>

          {/* Description */}
          <div className='col-lg-6 col-md-6 col-sm-12 v-align-middle p-0 order-lg-1 order-md-1 order-2'>
            <div className='services-item-content'>
              <h2>Ultra<span>sound</span></h2>

              <p>
                FamPhy provides reliable ultrasound imaging services to help diagnose
                and monitor a wide range of medical conditions. Our experienced
                radiologists use advanced ultrasound technology to deliver accurate,
                safe, and non-invasive diagnostic scans for pregnancy, abdominal,
                pelvic, thyroid, and other soft tissue examinations.
              </p>

              <Link to="/contact" className="btn theam-btn-m">
                Contact Us
              </Link>
            </div>
          </div>

          {/* Image */}
          <div className='col-lg-6 col-md-6 col-sm-12 p-0 order-lg-2 order-md-2 order-1'>
            <img
              className="img-fluid"
              src={`${process.env.PUBLIC_URL}/img/uv.png`}
              alt="Ultrasound"
            />
          </div>

        </div>
      </div>
    </>
  );
}